module.exports = {
      id: "cricket-usage",
      viewBox: "0 0 21.217 19.952",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#cricket",
      toString: function () {
        return this.url;
      }
    }